import { Row, Card } from 'antd'

import MagazineStyle from '../../styles/AuthorityMagazine.module.css'

const AuthorityMagazine = () => {
  const tilde = <span className={`${MagazineStyle["tilde"]}`}>~</span>
  return (
    <div className={`${MagazineStyle["authority-magazine-screen"]}`}>
      <Row justify="center">
        <Card className={`${MagazineStyle["authority-magazine-card"]}`}>
          <span className={`${MagazineStyle["date"]}`}>OCTOBER 15, 2020 | AUTHORITY MAGAZINE</span >
          <article>
            <figure className={`${MagazineStyle["right"]}`}>
              <img alt="Eric Poe - CURE Ceo" src="https://assets.cure.com/img/main-site/eric_half_pregnant.jpeg" />
              <figcaption>Eric Poe, Esq., CPA</figcaption>
            </figure>
            <h1 className={`${MagazineStyle["authority-magazine-title"]}`}>
              Eric Poe of CURE Auto Insurance: 5 Steps We Must Take To Truly Create An Inclusive, Representative, and
              Equitable Society
            </h1>
            <br />
            <p>
              I would turn to youth for the building of future leaders. One of the many lessons we have been reminded of
              in the past several months is the need to provide children with the tools they need to manage during
              tumultuous times. One tool that could prove useful would be to expand the current health curriculum in
              schools to include an aspect of “mental” well-being rooted in the concept of mindfulness. From a very
              young age, children need to be armed with understanding how to handle stress, conflict, and interpersonal
              relationships, while also becoming more comfortable with themselves.
            </p>
            <p>
              <i>
                As part of our series about ‘5 Steps We Must Take To Truly Create An Inclusive, Representative, and
                Equitable Society’ I had the pleasure to interview Eric Poe.
              </i>
            </p>
            <p>
              <i>
                As Chief Operating Officer of CURE Auto Insurance, Eric Poe oversees the operations of nearly 200
                employees and nearly $45 million in assets. He is a licensed active New Jersey attorney and Certified
                Public Accountant. Eric is responsible for the marketing, filing of rates, underwriting, claims, loss
                control, and litigation strategy for CURE.
              </i>
            </p>
            <p>
              <i>
                Eric Poe is credited as the outspoken catalyst and initial source of information on the topic of banning
                the use of education and occupation as income proxies in the car insurance industry. Mr. Poe’s influence
                has been instrumental in the ban of the industry practice in New York (2018) and Michigan (2019).
              </i>
            </p>
            <p>
              <i>
                As a recognized commentator in the insurance field, Eric Poe has testified on discriminatory rate setting
                practices twice before the United States House of Representatives (2008 and 2020), Committee on
                Financial Services (Subcommittee on Oversight and Investigations) in Washington D.C. on the topic of
                insurance scoring, and the availability and affordability of insurance. He has also testified a combined
                five times before the New Jersey Senate and Assembly, the Florida Office of Insurance Regulation, the
                New Hampshire Legislature as well as before the National Council of Insurance Legislators. In addition,
                Mr. Poe has appeared nationally on CNBC, Fox Business News, and regionally on ABC, CBS, NBC and WPHL as
                an authority in the field of insurance.
              </i>
            </p>
            <p>
              <i>
                Eric Poe was awarded NJBIZ’s “40 Under 40” award, recognizing him as one of the 40 most influential New
                Jersey business entrepreneurs under the age of 40. Poe regularly argues cases and has appeared several
                times before the New Jersey Supreme Court. In 2015, Mr. Poe successfully argued CURE v. Perez, before
                the New Jersey Supreme Court, overturning an Appellate Division decision. Additionally, in 2015, under
                Eric Poe’s leadership, CURE was nominated as NJBIZ’s “Business of the Year.” He was also named as one of
                New Jersey Law Journal’s Trailblazers in 2020 for his innovation and thought leadership in both the
                insurance and legal industries.
              </i>
            </p>

            <h5>
              Thank you so much for doing this with us! Before we dig in, our readers would like to ‘get to know you’.
              Can you tell us a bit about how you grew up?
            </h5>
            <p>
              I grew up where the “first shot” was fired in the American Revolution — Lexington, Massachusetts. It seems
              fitting that at times I feel like my life has been an uphill battle, like the few minutemen who stood
              against the British Red Coats while completely outnumbered. Their cause was for justice and they showed
              indisputable courage. Now, nearly two and a half centuries later, there are “battles” in the insurance and
              legal fields that I cannot ignore and am driven to push for change.
            </p>

            <h5>
              Is there a particular book that made a significant impact on you? Can you share a story or explain why it
              resonated with you so much?
            </h5>
            <p>
              The book is called “No Surrender” by James J. Sheeran, a paratrooper captured by the Germans in World War
              II. It tells a story of undeniable strength, from being shot at amid a planned train escape, to randomly
              landing in his mother’s childhood town behind enemy lines in France. After fighting with the underground
              French Marquis, he reunited with the U.S. Army, refused to return to America in order to stay in Europe
              and fight the battles of D Day and Market Basket. This was far more than a true-life non-fiction book.
              Sheeran was my stepfather, and his story touched me deeply. He passed away several years ago. To me, the
              title says it all — never surrender when fighting for your cause.
            </p>

            <h5>
              Do you have a favorite “Life Lesson Quote”? Do you have a story about how that was relevant in your life
              or your work?
            </h5>
            <p>
              I have two. First to come to mind is a George Bernard Shaw quote: “The reasonable man adapts himself to
              the world; the unreasonable one persists in trying to adapt the world to himself. Therefore, all progress
              depends on the unreasonable man.” This speaks to how I view the world. I never feel there is any rule,
              law, or norm that can’t be challenged and changed. I’m often heard responding to statements like, “Well,
              the current law is . . .” with “Well, I guess we will need to find a way to change the law.”
            </p>
            <p>
              The second is a more personal life-lesson quote by Bruce Lee: “Don’t pray for an easy life, pray for the
              strength to endure a difficult one.” This resonates with me because it embodies the principles of mindful
              leadership. It seems so many people in today’s society are increasingly sensitive to what other people say
              or do, as though they are under the false impression that how others think or feel is a rationale for
              their own reactions. I have learned that it is a waste of energy to believe we will ever control how other
              people think or feel. Instead, I believe we need to gain the strength needed to self-examine and to endure
              negative feelings or thoughts.
            </p>
            <p>
              As a father myself, I have seen firsthand how many parents today do not allow their children to experience
              life’s emotional challenges that oftentimes are vital ingredients for growth. I see too many adults try to
              shield kids from experiencing natural consequences. Prime examples of this are “participation trophies”
              and movements to eliminate high school Valedictorian awards, for fear of disappointing those who do not
              win. Efforts like these will only deny young people the opportunity for spiritual and social development.
              The difficult emotions experienced in defeat help build the eventual courage that children need to endure
              future obstacles. In the real world, there are frequently no awards for second place. They call it the
              school of hard knocks and, to me, that’s the only one that cultivates leaders.
            </p>

            <h5>How do you define “Leadership”? Can you explain what you mean or give an example?</h5>
            <p>
              I think it is two-fold. Leadership is the ability to provide courage for those around you who otherwise
              lack courage, and to motivate them to work collectively for a goal that reaches beyond what they would
              accomplish absent that leader. An example of this is Michael Jordan, who is not only viewed as the best
              basketball player, he is one of the greatest leaders. Why? Because he pushed his teammates to work harder
              and to challenge their own expectations for a higher goal. Great leaders must show vulnerability (and be
              comfortable doing so), along with courage, so others understand the pain and sacrifice that even the
              leader must endure to reach the collective goal.
            </p>

            <h5>
              Ok, thank you for all that. Now let’s move to the main focus of our interview. The United States is
              currently facing a very important self-reckoning about race, diversity, equality and inclusion. This is of
              course a huge topic. But briefly, can you share your view on how this crisis inexorably evolved to the
              boiling point that it’s at now?
            </h5>
            <p>
              In my opinion, the issues in today’s society largely result from the failure of the ancient Asian
              principle Yin and Yang {tilde} the theory of two interdependent opposites. While I believe our country was
              founded on the ideals of capitalism, there are limits to such a system. We have done a poor job of
              creating those boundaries, primarily because the system created by our forefathers never contemplated the
              impact of special interest groups and campaign funding. The result {tilde} a highly blurred line in certain
              industries that I personally feel should have some sort of “profit regulations” because they provide
              essential and utilitarian life needs. For example, energy, food, healthcare, housing, and insurance serve
              fundamental needs in our society and should have greater governmental oversight through regulation than
              other traditional industries. Without balance in these areas, capitalistic ideals can go too far and have
              a detrimental effect on our society.
            </p>
            <p>
              An example? Well, I understand the argument of pharmaceutical companies. They need an incentive to explore
              and invent new drugs that help mankind. However, assigning a 20-year patent and allowing those drug
              companies to charge exorbitant and unchallenged prices for the same 20 years yields billions of dollars in
              unnecessary profits. There should be thresholds to these incentives when profits begin to matter more than
              the detrimental effect the exploding healthcare costs have on society. In situations such as these, I
              would implement excess profit laws that cap profit margins at, say, 10% of revenues on a three-year
              rolling basis. Even with such a limit, I am confident hundreds of millions of dollars a year in profits
              would still exist and would be incentive enough for companies to continue researching new drugs to help
              people throughout the world.
            </p>
            <p>
              Why don’t we see reform and regulation of these essential industries? In my opinion, it’s a result of
              highly strategic efforts to influence key policy makers and which ultimately contribute to countless
              societal issues: the exploding costs of genetically modified organisms (GMOs) in our food supply; the
              unconscionably high interest rates charged to the poor for housing and loans; and, the higher costs
              incurred by those in our society whose only crime is less than good credit, which is correlated to income.
              So here we are today with such a large income divide in the population.
            </p>
            <p>
              I have come to learn that “Corporate America” depends on a system of lobbying efforts — one that is geared
              to the interests of those who can pay the lobbyists. As a result, the poor have no voice. How can they
              hire lobbyists to play the “game” when they can barely pay for food or housing? The current system rewards
              initiatives that are brought to light by big businesses with greater lobbying power. Since the poor offer
              no large buying power, Corporate America is willing to disregard the bottom 20% of all income earners
              unless they find a way to monetize them.
            </p>
            <p>
              Before continuing on the social issues, I feel it is important for me to say that I do not speak from
              personal experience of being a racial minority that has been negatively impacted by some of these
              practices. I don’t walk in the shoes of anyone but by own. Instead, my opinions are shaped through
              observation and information gathered from thought leaders, media, peers, and those underserved — all of
              whom have various perspectives. The truth is that poverty disproportionately affects minorities.
              Therefore, I have come to believe the many of the racial issues we face today are a direct result of a
              failed infrastructure that does not provide opportunities for those in need to help them escape the
              perpetual cycle of poverty. Instead, for example, we have fostered their disadvantage through the passage
              of unfair criminal punishment such as targeting drug enforcement predominantly in the poorer
              neighborhoods.
            </p>
            <p>
              Further still, the diminishment of hope for those in poverty has created a cultural problem within
              families as well. For example, it should come as no surprise the culturally devastating effects over time
              of jailing so many Black men. Statistically in the U.S., Black babies are born to single parents and
              households with no dual income more than any race. For example, in 1965, a year after the Civil Rights Act
              was passed, 24% of Black infants were born to single mothers. By 1990, the rate for Black babies being
              born to single parent households had exploded to 64% percent and, according to the U.S. Census, this
              number further increased to 72% in 2011. It is worth noting that this is three times the percentage of
              White American infants being raise by a single parent.
            </p>
            <p>
              So let’s look at the big picture. In many poorer areas, we have a lack of two parents providing guidance
              for children, a lack of dual-incomes, as well as a strained and over-populated school system. Add to that
              few if any visible opportunities for upward income growth due to discriminatory corporate policies — and
              here we are today.
            </p>
            <p>
              I strongly believe the biggest challenge is addressing the lack of opportunity for those in poverty — a
              group disproportionately comprised of racial minorities — and providing ways individuals can climb the
              income class ladder.
            </p>

            <h5>
              Can you tell our readers a bit about your experience working with initiatives to promote diversity and
              inclusion? Can you share a story with us?
            </h5>
            <p>
              Although my commitment to equality has been lifelong, this initiative really hit home when I saw the
              glaring inequities that result from the insurance industry’s use of “income proxies,” such as education,
              occupation, and credit score, in car insurance rate-setting. I have become known as a whistleblower within
              my industry — one that charges an upwards of 60% more for car insurance to people simply because they are
              poor, not because they are unsafe drivers. By holding down those in poverty, we continue to perpetuate the
              socio-economic divide that grips our nation.
            </p>
            <p>
              Having spent 15 years crusading for a ban on such pervasive and discriminatory practices, I believe we are
              at a turning point- and the current “self-reckoning,” as noted in your prior question, the possibility for
              action at both the state and federal level is growing. While this may be only one piece of a large puzzle,
              it is a needed one.
            </p>

            <h5>
              This may be obvious to you, but it will be helpful to spell this out. Can you articulate to our readers a
              few reasons why it is so important for a business or organization to have a diverse executive team?
            </h5>
            <p>
              I pride myself in recognizing that no one person or perspective can be the answer to the challenges we
              face today. Think back to the 1970s when Chevrolet made an infamous decision to introduce its best-selling
              car at the time (the Chevy Nova) in Mexico. What they did not consider was that in Spanish “no va” means
              “no go” and many would not want a car with such a name. This is only one example and we do not need to
              look too far to realize that diversity in the executive team allows for an understanding that filters
              throughout the entire organization, and broadens the perspectives of how the organization approaches
              consumers.
            </p>

            <h5>
              Ok. Here is the main question of our discussion. You are an influential business leader. Can you please
              share your “5 Steps We Must Take To Truly Create An Inclusive, Representative, and Equitable Society”.
              Kindly share a story or example for each.
            </h5>
            <p>
              Step one is recognizing one of the key components inherent within the Civil Rights Act. What many do not
              realize is that the Act is based on intent. Knowing a practice has a negative effect on a class is NOT
              enough; it requires that a policy is adopted with the purpose of discriminating against a particular race.
            </p>
            <p>
              In the years that followed the 1964 Civil Rights Act and 1965 Voting Rights Act, the need to show “intent”
              was addressed in the housing industry with passage of the Fair Housing Act (FHA). Leaders realized that
              facially neutral practices, such as requiring advanced degrees to buy a house within certain areas, would
              have clearly negative discriminatory impact, and were, in effect, racist “redlining”. However, outside the
              FHA, these rules do not necessarily apply, and facially-neutral practices still fly under the radar.
            </p>
            <p>
              I can look at my own industry for an example of policies that may seem “fair” on their face, yet clearly
              have a disproportionate negative impact on people with lower incomes. Some of the largest car insurance
              companies use “income proxies” {tilde} education, occupation and credit score {tilde} in rate setting, and charge the
              highest rates to consumers who can least afford it, despite the applicant’s safe driving record.
            </p>
            <p>
              Following as close second would be to remove credit utilization as a factor in determining credit score.
              When most individuals hear the term credit score, they think of payment history. Does one pay their bills
              on time or are they frequently late? Yes it is true, payment history (i.e., paying on time) represents 35%
              of one’s credit score. But unknown to many is the fact that credit utilization (or the amount of one’s
              credit line that is already used) weighs in at 30% of a credit score. Why would this matter if this person
              pays on time?
            </p>
            <p>
              I believe that prohibiting the use of credit utilization in credit scores is so important because the use
              of credit lines offered by lenders are directly calculated upon a borrower’s income. At CURE, we did an
              in-house analysis and found the scoring model reduced a person’s credit score significantly based on the
              consumer’s outstanding debt to their granted credit line. As a result, we concluded that credit scores
              calculated in this fashion are a strong predictor of a person’s income.
            </p>
            <p>
              As a third step, I would recommend a uniform model equalization program of state budgets and allocation of
              funds to assist local municipalities in need. Subsidies are needed for those cities and towns in which
              property values result in lower tax revenue. These same areas are also home to the poorest residents in
              their respective states, so the income taxes generated in these areas are also very low. I would use the
              sheer metrics of Medicaid as a criteria in determining which areas have the greatest need, and then
              provide state aid accordingly, without any subjectivity or lobbying. To cite an example, you see wealthier
              townships with traditionally lower crime rates, have a police force paid more than law enforcement
              officers who work within lower income areas, where the crime rate might be significantly higher. The equal
              allocation of funds for the police, schools, and other essential township services is essential to ending
              the cycle of poverty.
            </p>
            <p>
              A fourth step would be to look at the number of municipalities across the country and create a consistent
              framework for each, allowing for fewer municipalities, each covering a larger area. Specifically, we
              should create standardization using a matrix that defines municipalities based on population and
              geographic size. Currently the boundaries were defined decades or sometimes hundreds of years ago, at a
              time before cars, telephones, and many of the other technological advancements we have today. At that
              time, the smaller borders made sense because of lower populations, the lack of an adequate transportation
              that could cover that much land, and a communication infrastructure which relied upon telegraphs or word
              of mouth. Imagine the limitations of horse and buggies versus cars, ambulances, and helicopters. The
              result today, however, is an overabundance of municipalities, a correspondingly higher property tax rate
              for these redundant services and a greater cost of living.
            </p>
            <p>
              It is mind-boggling really. In New Jersey alone, there are more than 500 municipalities. Despite the major
              population growth over the past few decades, all these municipalities still exist which minimize the
              economies of scale leading to New Jersey’s ridiculous property tax burden.
            </p>
            <p>
              Consolidation may sound easy, but it’s not. In order to combine municipalities now, one would have to
              convince many local leaders and government officials to agree to eliminate their roles. What politician
              would ever be willing to initiate change that could potentially eliminate their own position? It would
              also involve job elimination within many of the common services, such as law enforcement, court
              administrators, tax assessors, and other township employees. This is why we don’t see unification.
            </p>
            <p>
              Lastly, as a fifth step, I would turn to youth for the building of future leaders. One of the many lessons
              we have been reminded of in the past several months is the need to provide children with the tools they
              need to manage during tumultuous times. One tool that could prove useful would be to expand the current
              health curriculum in schools to include an aspect of “mental” well-being rooted in the concept of
              mindfulness. From a very young age, children need to be armed with understanding how to handle stress,
              conflict, and interpersonal relationships, while also becoming more comfortable with themselves.
            </p>
            <p>
              The sad truth is that studies show that suicide deaths in children is on the rise. Further, there is a
              link between higher poverty and incidents of suicide. If for no other reason, we need to find ways empower
              our next generation with mindful strength to grow.
            </p>

            <h5>
              We are going through a rough period now. Are you optimistic that this issue can eventually be resolved?
              Can you explain?
            </h5>
            <p>
              Sadly, I am not sure, but I do believe that nothing will change until we address the biggest issue facing
              our society today {tilde} a system that creates accountability in Corporate America for those in poverty. In my
              opinion, a lot of media and public attention has been focused on the federal responses to these issues,
              but it is the state and local governments that have failed to address poverty in a meaningful way that can
              create opportunities. I don’t believe in a system of “handouts,” yet feel strongly that we need to protect
              those who are economically disadvantaged. Our local government needs to address state tax funding better
              in order to revitalize local poor neighborhoods and provide hope through opportunity.
            </p>
            <p>
              I often ask … how will poor neighborhoods ever have the sufficient property tax funding needed to improve
              education, provide after school programs and provide adequate law enforcement protection and oversight, if
              the homes are worth a small fraction of the homes in middle and upper income neighborhoods? How can these
              same poor neighborhoods gain proper tax funding when the lowest income residents are not able to pay
              income taxes to their municipalities because they are unemployed? When we create pockets of poverty and
              adopt practices that prevent people that live in the pockets from the opportunity to work their way up the
              income ladder, we have a perpetual cycle of poverty.
            </p>
            <p>
              Despite, or regardless, of the position of our U.S. President, these issues are generation-old state and
              local issues. We need to create more local accountability, and people need to know the voting track
              records of their state legislators. This includes asking these politicians to become more politically
              involved in local districts and address the issues that matter locally. Our local newspapers are dying
              because the national media has not recognized their role in helping to shape these narratives. We need to
              stop focusing on huge national politics. Instead, we need the media to return to its grass roots by
              covering local legislative proposals and helping to identify which politicians are, or are not, supporting
              these proposals. There should be greater outrage when a local senator or assemblyman does not vote in a
              way that would be beneficial to their local supporters. I have often thought about the creation of local
              watchdog groups that focus on certain essential needs and raise awareness so that the local media will
              cover — and draw attention to — the issues raised by these groups.
            </p>

            <h5>
              Is there a person in the world, or in the US, with whom you would like to have a private breakfast or
              lunch, and why? He or she might just see this, especially if we tag them. :-)
            </h5>
            <p>
              My first choice would be to have a full American breakfast with Alexander Hamilton, but he is long gone.
              If I am to choose someone alive today, I guess it would be a more “English-style” menu with Elon Musk.
              Seriously, having admired Ralph Nader and his efforts from the 1960s through the 1980s, I feel Elon Musk
              deserves far more credit than just that of a successful entrepreneur. He chose to defy the odds by
              creating a new line of cars that revolutionized the industry and impacted the world. Instead of being one
              of the many that directly compete side-by-side, he challenged other century-old manufacturers to follow
              his lead. The successful introduction of electric cars is monumental globally and now others have had to
              catch up in order to compete. Musk exemplifies what in means to be a visionary {tilde} someone unafraid of
              his/her idea. He embraces his goals and follows through to the end. Clearly, Musk has made a nice profit,
              but he is also making the world a better place.
            </p>

            <h5>How can our readers follow you online?</h5>
            <p><a href='https://www.linkedin.com/in/eric-poe-a34865' target='_blank'>Yes LinkedIn</a></p>

            <h5>This was very meaningful, thank you so much. We wish you only continued success on your great work!</h5>

            <hr />
          </article>
        </Card>
      </Row>
    </div>
  )
}

AuthorityMagazine.propTypes = {}

export default AuthorityMagazine
